import React from 'react';
import "./index.css";
import {Link} from 'gatsby';

export class SectionTopImage extends React.Component {


    render(){
        const {title, subtitle, customClass} = this.props;
        const {actionTitle} = this.props.actionButton || {};
        return (
            <div className={`layout-0 ${customClass || ''}`}>
                <div className='layout-overlay-1'>
                    <div className='layout-overlay-1-text'>
                    <h1 className='secondary'>{title}</h1>
                    <h2>{subtitle}</h2>
                    {
                        actionTitle ? 
                            <Link to="/about-us" className='pure-button secondary-button action-call-button'>
                                {actionTitle}
                            </Link>
                             :
                        <></>
                    }
                    </div>
                </div>
            </div>
        );
    }
}